import * as VideoManager from './VideoManager.js';
import * as HostController from './HostController.js';

export function Initialize() {
	document.addEventListener('video_ended', OnVideoEnd);
	document.addEventListener('video_cuepoint', CuePointHandler);
	document.addEventListener('timer_end', (event) => {
		TimerCallback();
	});

	setTimeout(() => {
		for (let i = 0; i < 4; i++) {
			if (document.getElementById('ves-option-' + (i + 1)) != null) {
				document
					.getElementById('ves-option-' + (i + 1))
					.addEventListener('click', () => {
						document.getElementById('pc-videoend').style.display = 'none';
						document.getElementById('video').classList.remove('d-none');
						MakeDecision(i + 1);
					});
			}
		}
	}, 1000);
}

//////////////////
// Public functions
////////////////

export function StartScene(tag) {
	result = false;
	decisionsShown = false;
	document.getElementById('intro-sound').pause();
	document.activeElement.blur();
	HostController.WSCall({ type: 'scenario-start' });
	document.getElementById('video').classList.remove('d-none');

	let newScene = scenarios[tag];
	if (newScene != null) {
		VideoManager.Load(newScene.videoId, newScene.decisionTimestamp);
		currentScene = tag;

		// Setup decisions

		SetupDecisions(newScene.decisions);
	}
}

//////
// Scenario Handling
//////////

let currentScene;
let currentDecision;

let scenarioEndEvent = new Event('scenario_end');

let result = false;

let decisionsShown = false;

function OnVideoEnd() {
	if (result) {
		document.dispatchEvent(scenarioEndEvent);
		// document.getElementById('ves').classList.add('active');
		document.getElementById('video').classList.add('d-none');
		HostController.WSCall({ type: 'scenario-end' });
	} else if (currentScene != null && !decisionsShown) {
		StartDecisionPhase();
	}
}

function CuePointHandler(event) {
	switch (event.detail.data.event) {
	case 'end':
		VideoManager.Pause();
		OnVideoEnd();
		break;
	case 'decisions':
		StartDecisionPhase();
		break;
	}
}

function StartDecisionPhase() {
	if (decisionsShown) return;
	decisionsShown = true;

	VideoManager.Pause();
	ShowDecisions();

	setTimeout(() =>
		HostController.StartDecisions(scenarios[currentScene].decisions)
	, 5000);
}

////////////
// Decisions
///////////

export function MakeDecision(id) {
	VideoManager.Load(scenarios[currentScene].decisions[id - 1].videoId);
	result = true;
	//VideoManager.SetPlaybackPosition(scenarios[currentScene].decisions[id - 1].timestamp);
	//VideoManager.Play();
	HideDecisions();
}

function ShowDecisions() {
	// The app normally plays a "Wat zou jij doen?" voice-over when the vote
	// starts. Videos that already contain that line set voiceOverInVideo.
	if(scenarios[currentScene].voiceOverInVideo){
		// nothing to play, the video did it
	} else if(scenarios[currentScene].newVO){
		document.getElementById('decisions-sound-new').play();
	} else{
		document.getElementById('decisions-sound-old').play();
	}
	document.getElementById('host-answercounter').classList.remove('d-none');
	StartTimer();
}

function HideDecisions() {
	HostController.WSCall({ type: 'decision-end' });
}

function SetupDecisions(decisions) {
	for (let i = 0; i < decisions.length; i++) {
		document.getElementById('decision-' + (i + 1)).innerHTML =
      decisions[i].text;
		document.getElementById('ves-option-' + (i + 1)).innerHTML =
      decisions[i].text;
	}
}

////////////
// Timer
//////////////

const TimerDuration = 30; // seconds

function StartTimer() {
	document.dispatchEvent(new CustomEvent('start-timer', {
		detail: {},
	}));
}

function TimerCallback() {
	HostController.VotingFinished();
}

///////
// Data
///////

export let scenarios = {
	// Online

	0: {
		videoId: '488979387',
		decisionTimestamp: 45,
		endthumbnail: '',
		decisions: [
			// Decision 1
			{
				text: 'Delen met de klas',
				videoId: '493728977',
			},
			// Decision 2
			{
				text: 'Melden bij mentor',
				videoId: '493729129',
			},
			// Decision 3
			{
				text: 'Liken en reageren',
				videoId: '493729206',
			},
			// Decision 4
			{
				text: 'Afkeuren in comment',
				videoId: '493729291',
			},
		],
	},
	// Aanmeld formulier

	1: {
		videoId: '505560221',
		decisionTimestamp: 65,
		decisions: [
			// Decision 1
			{
				text: 'Fatma zelf laten kiezen',
				videoId: '505560443',
			},
			// Decision 2
			{
				text: 'Fatma aanmoedigen',
				videoId: '505560482',
			},
			// Decision 3
			{
				text: 'Fatma ontmoedigen',
				videoId: '505560519',
			},
			// Decision 4
			{
				text: 'Iedereen uitnodigen',
				videoId: '505560585',
			},
		],
	},

	// Achterin de bus

	2: {
		videoId: '488981091',
		decisionTimestamp: 67,
		decisions: [
			// Decision 1
			{
				text: 'Boos worden',
				videoId: '493729391',
			},
			// Decision 2
			{
				text: 'Jesse steunen',
				videoId: '493729499',
			},
			// Decision 3
			{
				text: 'Niets doen',
				videoId: '498291421',
			},
			// Decision 4
			{
				text: 'Meelachen',
				videoId: '493729941',
			},
		],
	},

	// Dugout

	3: {
		videoId: '488981435',
		decisionTimestamp: 51,
		decisions: [
			// Decision 1
			{
				text: 'Meedoen met Denise',
				videoId: '493730076',
			},
			// Decision 2
			{
				text: 'Niets doen',
				videoId: '493730220',
			},
			// Decision 3
			{
				text: 'Denise kalmeren',
				videoId: '493730234',
			},
			// Decision 4
			{
				text: 'Er iets van zeggen',
				videoId: '493730323',
			},
		],
	},

	// De cornervlag

	4: {
		videoId: '488979533',
		decisionTimestamp: 62,
		decisions: [
			// Decision 1
			{
				text: 'Doorspelen',
				videoId: '493730727',
			},
			// Decision 2
			{
				text: 'Stoppen met spelen',
				videoId: '493730856',
			},
			// Decision 3
			{
				text: 'Scheids roepen',
				videoId: '493730946',
			},
			// Decision 4
			{
				text: 'Afwachten wat Tarik doet',
				videoId: '493731062',
			},
		],
	},

	// Penalty

	5: {
		videoId: '488981750',
		decisionTimestamp: 67,
		decisions: [
			// Decision 1
			{
				text: 'Opnemen voor Sarah',
				videoId: '493731134',
			},
			// Decision 2
			{
				text: 'Snel Sarah kiezen',
				videoId: '493731440',
			},
			// Decision 3
			{
				text: 'Mitchell gelijk geven',
				videoId: '493731521',
			},
			// Decision 4
			{
				text: 'Zelf laten uitzoeken',
				videoId: '493732560',
			},
		],
	},

	// Kleedkamer

	7: {
		videoId: '1222070873',
		decisionTimestamp: 58,
		voiceOverInVideo: true,
		decisions: [
			// Decision 1
			{
				text: 'Michiel kalmeren',
				videoId: '1222070874',
			},
			// Decision 2
			{
				text: 'Melden bij docent',
				videoId: '1222070878',
			},
			// Decision 3
			{
				text: 'Noor troosten',
				videoId: '1222070877',
			},
			// Decision 4
			{
				text: 'Verder vieren',
				videoId: '1222070936',
			},
		],
	},

	// Tafelvoetbal

	8: {
		videoId: '493769018',
		decisionTimestamp: 77,
		decisions: [
			// Decision 1
			{
				text: 'Niets doen',
				videoId: '493732727',
			},
			// Decision 2
			{
				text: 'Bram troosten',
				videoId: '493732827',
			},
			// Decision 3
			{
				text: 'Opkomen voor Bram',
				videoId: '493732922',
			},
			// Decision 4
			{
				text: 'Meelachen',
				videoId: '493732948',
			},
		],
	},

	// De Parkeerplaats

	10: {
		videoId: '1222070321',
		decisionTimestamp: 46,
		voiceOverInVideo: true,
		decisions: [
			// Decision 1
			{
				text: 'Niets doen',
				videoId: '1222070319',
			},
			// Decision 2
			{
				text: 'Er iets van zeggen',
				videoId: '1222070320',
			},
			// Decision 3
			{
				text: 'Bal schieten',
				videoId: '1222070322',
			},
			// Decision 4
			{
				text: 'De jongens afleiden',
				videoId: '1222070393',
			},
		],
	},
	// de prijsuitreiking
	9: {
		videoId: '1152894655',
		decisionTimestamp: 64,
		newVO: true,
		decisions: [
			// Decision 1
			{
				text: 'Meelachen',
				videoId: '1152894714',
			},
			// Decision 2
			{
				text: 'Filmpje delen',
				videoId: '1152894621',
			},
			// Decision 3
			{
				text: 'Weglopen',
				videoId: '1152894547',
			},
			// Decision 4
			{
				text: 'Er iets van zeggen',
				videoId: '1152894591',
			},
		],
	},
	// rode kaart
	6: {
		videoId: '1222072133',
		decisionTimestamp: 78,
		voiceOverInVideo: true,
		decisions: [
			// Decision 1
			{
				text: 'Boos worden op scheids',
				videoId: '1222072136',
			},
			// Decision 2
			{
				text: 'Boos worden op Wesley',
				videoId: '1222072137',
			},
			// Decision 3
			{
				text: 'Streng toespreken',
				videoId: '1222072134',
			},
			// Decision 4
			{
				text: 'Advies geven',
				videoId: '1222072242',
			},
		],
	},

};
Initialize();
